/**
 * @generated SignedSource<<7b4e9ad6c09da6a8063ad6a023f3c1cd>>
 * @relayHash abe5c2a17dd0e511abed63b04d9020b9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f41abc1f87cea1d92d3895ce8063367ac811d6ce81e2fbd95c4b7962b9ff8c9b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type fetchAppRecommendationsQuery$variables = {
  cloudId: string;
};
export type fetchAppRecommendationsQuery$data = {
  readonly growthRecommendations: {
    readonly recommendations: {
      readonly data?: ReadonlyArray<{
        readonly entityId?: string;
      }> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type fetchAppRecommendationsQuery = {
  response: fetchAppRecommendationsQuery$data;
  variables: fetchAppRecommendationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Literal",
        "name": "product",
        "value": "jira"
      },
      {
        "kind": "Variable",
        "name": "tenantId",
        "variableName": "cloudId"
      },
      {
        "kind": "Literal",
        "name": "useCase",
        "value": "jiraProjectMenuRecommendations"
      }
    ],
    "kind": "ObjectValue",
    "name": "context"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 2
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "entityId"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "fetchAppRecommendationsQuery",
    "selections": [
      {
        "concreteType": "GrowthRecQuery",
        "kind": "LinkedField",
        "name": "growthRecommendations",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "recommendations",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": (v2/*: any*/),
                            "action": "THROW",
                            "path": "growthRecommendations.recommendations.data.entityId"
                          }
                        ],
                        "type": "GrowthRecJiraTemplateRecommendation"
                      }
                    ]
                  }
                ],
                "type": "GrowthRecRecommendations"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "fetchAppRecommendationsQuery",
    "selections": [
      {
        "concreteType": "GrowthRecQuery",
        "kind": "LinkedField",
        "name": "growthRecommendations",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "recommendations",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*: any*/)
                        ],
                        "type": "GrowthRecJiraTemplateRecommendation"
                      }
                    ]
                  }
                ],
                "type": "GrowthRecRecommendations"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f41abc1f87cea1d92d3895ce8063367ac811d6ce81e2fbd95c4b7962b9ff8c9b",
    "metadata": {},
    "name": "fetchAppRecommendationsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e60e2bfdf0465b06eb972742a756d745";

export default node;
